import {useQuery, gql} from "@apollo/client";

var PRODUCT_PAGE_HEADER = gql`
query ProductPageHeader {
    productPageHeader(where: {localization: {culture_starts_with: "fa"}}) {
      displayText
      productPageHeaderImage {
        urls(first: 1)
      }
      productPageHeaderLink {
        url
        text
      }
      productPageHeaderSubtitle {
        html
      }
    }
  }
  `;

export const useProductPageHeader = () => {
    const {error, data, loading} = useQuery(PRODUCT_PAGE_HEADER);
    return {
      error,
      data,
      loading
    }
  }